import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { MassCommService } from '../../../communication/shared/mass-comm.service';
import { InvoiceAdvancedSearch } from '../../shared/invoice/invoice-advanced-search.model';
import { MessageDraftProfileSearch } from '../../../communication/shared/message-draft-profile-search.model';
import { UserRead } from '../../../users/shared/user-read.model';
import { UserService } from 'src/app/users/shared/user.service';
import { Message } from '../../../communication/shared/message.model';
import { ConfigService } from '../../../config/shared/config.service';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HtmlTemplate } from 'src/app/templates/shared/html-template.model';
import { HtmlTemplateService } from 'src/app/templates/shared/html-template.service';
import { AssociationInfo } from 'src/app/config/shared/association-info.model';
import { ReplaceEmailAddressOptionEnum } from 'src/app/communication/shared';
import { Params } from '@angular/router';

@Component({
  selector: 'wl-transactions-grid-email-dialog',
  templateUrl: './transactions-grid-email-dialog.component.html',
  styleUrls: ['./transactions-grid-email-dialog.component.less'],
    standalone: false
})
export class TransactionsGridEmailDialogComponent implements OnInit {
  @Input() show: boolean;
  @Input() invoiceSearch: InvoiceAdvancedSearch;
  @Output() cancelClicked: EventEmitter<any> = new EventEmitter();
  public htmlTemplates: HtmlTemplate[];
  public selectedHtmlTemplate: HtmlTemplate;
  public isCreatingEmail: boolean;
  public organizationName: string;

  constructor(
    private _htmlTemplateService: HtmlTemplateService,
    private _configService: ConfigService,
    private _userService: UserService,
    private _massCommService: MassCommService,
    private _navigationService: NavigationService
  ) {}

  ngOnInit() {
    this._htmlTemplateService.getHtmlTemplates().then((templates) => {
      this.htmlTemplates = templates;
    });
    this._configService.getAssociationInfo().then((data: AssociationInfo) => {
      this.organizationName = data.OrgName;
    });
  }

  createDraft() {
    this.isCreatingEmail = true;
    this._userService.getCurrentUser().then((user) => {
      const messageDraft = this.buildMessage(user);
      this._massCommService.createDraftMessage(messageDraft).then((draftId) => {
        this.isCreatingEmail = false;
        const queryParams = { isInvoiceEmail: true } as Params;
        this._navigationService.navigate(`communications/message/draft/${draftId}`, queryParams);
      });
    });
  }

  private buildMessage(currentUser: UserRead) {
    const message = new Message();
    message.Subject = `Invoice from ${this.organizationName}`;
    message.SendFrom = currentUser.Email;
    message.SendFromDisplayName = currentUser.FullName;
    message.ReplaceEmailAddressOption = ReplaceEmailAddressOptionEnum.BillingContact;
    message.ProfileSearchParams = this.buildProfileSearchParams();
    if (this.selectedHtmlTemplate) {
      message.Message = `${this.selectedHtmlTemplate.HTML}\n<p>[[PRINTABLEINVOICE]]</p>\n`;
    } else {
      message.Message = '<p>[[PRINTABLEINVOICE]]</p>\n';
    }
    return message;
  }

  private buildProfileSearchParams() {
    const searchParams = new MessageDraftProfileSearch();
    searchParams.ReplaceEmailAddressOption = ReplaceEmailAddressOptionEnum.BillingContact;
    searchParams.UnionInvoiceSearches.push(this.invoiceSearch);
    return searchParams;
  }
}
